import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ButtonComponent';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';

import { TermsContentProps, TermsContentRenderer } from '../utils/terms-and-conditions-utils';
import { PredictionTncAcknowledgement } from './PredictionTncAcknowledgement';

const PredictionTermsContent = ({
    hasAcceptedTerms,
    handleToggle,
    handleAcceptPress,
    handleWebViewOpened,
}: TermsContentProps) => {
    const { t } = useTranslation('prediction_access');

    return (
        <>
            <Text variant={'titleMedium'} textAlign={'center'} lineHeight={48}>
                {t('acknowledgement_title')}
            </Text>
            <Box px="s16">
                <PredictionTncAcknowledgement
                    value={hasAcceptedTerms}
                    toggleValue={handleToggle}
                    onWebViewOpened={handleWebViewOpened}
                />
            </Box>
            <SizedBox value={16} />
            <Box mx="s24">
                <Button
                    label={t('agree_and_continue')}
                    disabled={!hasAcceptedTerms}
                    hierarchy="primaryLilac"
                    onPress={handleAcceptPress}
                />
            </Box>
        </>
    );
};

export const renderPredictionTerms: TermsContentRenderer = params => <PredictionTermsContent {...params} />;
